export default function PRReportPackagesController() { /* provided only for controllerAs binding */ }
